import { Injectable } from "@angular/core";
import { AppConfig } from "../shared/constants/app.config";
import { Patient } from "../model/patient.";
import { UtilityService } from "../shared/service/utility.service";


@Injectable()
export class CibmtrPatientService {
  constructor(

    readonly utilityService: UtilityService,

  ) { }

  // Update the existing ehr patient with the CRID value in FHIR Server.
  appendCridIdentifier(
    ehrpatient: Patient,
    crid: string,
    logicalId: string,
    psScope: string
  ) {
    const {
      id,
      identifier,
      ...remainingfields
    } = ehrpatient;

    return {
      ...remainingfields,
      meta: {
        security: [
          {
            system: AppConfig.CIBMTR_CENTERS_NAMESPACE,
            code: psScope,
          },
        ],
      },
      identifier: [
        ...identifier,
        {
          use: "official",
          system: AppConfig.FHIR_LOGICALID_NAMESPACE,
          value:
            `${this.utilityService.rebuild_DSTU2_STU3_Url(localStorage.getItem("iss"))}/Patient/${logicalId}`
        },
        {
          use: "official",
          system: AppConfig.CIBMTR_CRID_NAMESPACE,
          value: `${crid}`
        },
      ],
    };
  }

  //Update Patient Record
  mergedPatient(ehrpatient: Patient, cibmtrPatient: any) {
    const {
      identifier,
      meta,
    } = cibmtrPatient;

    return {
      ...ehrpatient,
      meta: {
        ...meta,
      },
      identifier: [
        ...identifier,
        {
          use: "official",
          system: AppConfig.FHIR_LOGICALID_NAMESPACE,
          value: `${this.utilityService.rebuild_DSTU2_STU3_Url(localStorage.getItem("iss"))}/Patient/${ehrpatient.id}`,
        },
      ],
      id: cibmtrPatient.id,
    };
  }

  getRaceCodes(ehrpatient) {
    if (!ehrpatient?.extension?.length) {
      return {
        validCodes: [],
        hasInvalid: false,
        updatedPatient: ehrpatient
      };
    }
    
    const raceExtension = ehrpatient.extension.filter((ext) =>
      ext.url.includes(AppConfig.RACE_DEFINITION)
    );
  
    const extracted = raceExtension
      .map((outerEle) => {
        return (
          outerEle.extension &&
          outerEle.extension.filter((innerEle) => innerEle.valueCoding)
        );
      })
      .filter((a) => a !== undefined && a.length > 0)
      .reduce((acc, val) => acc.concat(val), [])
      .map((i) => i.valueCoding);
  
    const validCodes = extracted.filter(
      (vc) =>
        AppConfig.RACE_OMB_SYSTEM.includes(vc.system) &&
        AppConfig.RACE_OMB_CODES.includes(vc.code)
    ).map((vc) => vc.code);
  
    const invalidCodes = extracted.filter(
      (vc) =>
        !(
          AppConfig.RACE_OMB_SYSTEM.includes(vc.system) &&
          AppConfig.RACE_OMB_CODES.includes(vc.code)
        )
    );

    const updatedPatient = invalidCodes.length > 0 
      ? this.removeInvalidRaceCodes(ehrpatient)
      : ehrpatient;
  
    return {
      validCodes,
      hasInvalid: invalidCodes.length > 0,
      updatedPatient
    };
  }

  removeInvalidRaceCodes(ehrpatient) {
    if (!ehrpatient?.extension?.length) {
      return ehrpatient;
    }

    const updatedExtensions = ehrpatient.extension.map(ext => {
      if (ext.url.includes(AppConfig.RACE_DEFINITION)) {
        const validRaceExtensions = ext.extension?.filter(innerExt => {
          if (!innerExt.valueCoding) return false;
          return AppConfig.RACE_OMB_SYSTEM.includes(innerExt.valueCoding.system) &&
                 AppConfig.RACE_OMB_CODES.includes(innerExt.valueCoding.code);
        });
        return { ...ext, extension: validRaceExtensions };
      }
      return ext;
    }).filter(ext => ext.extension?.length > 0 || !ext.url.includes(AppConfig.RACE_DEFINITION));

    return { ...ehrpatient, extension: updatedExtensions };
  }
  
  getEthnicityCode(ehrpatient) {
    //filter ethnicity
    const ethnicityExtension = ehrpatient.extension.filter((ext) =>
      ext.url.includes(AppConfig.ETHINCITY_DEFINITION)
    );

    return ethnicityExtension
      .map((outerEle) => {
        return (
          outerEle.extension &&
          outerEle.extension.filter(
            (innerEle) =>
              innerEle.valueCoding &&
              AppConfig.ETHNICITY_OMBSYSTEM.includes(
                innerEle.valueCoding.system
              )
          )
        );
      })
      .filter((a) => a !== undefined && a.length > 0)
      .reduce((acc, val) => acc.concat(val), [])
      .map((i) => i.valueCoding && i.valueCoding.code)
      .join();
  }
}
